import { render, staticRenderFns } from "./AliOssManager.vue?vue&type=template&id=3c02f2c6&scoped=true"
import script from "./AliOssManager.vue?vue&type=script&lang=js"
export * from "./AliOssManager.vue?vue&type=script&lang=js"
import style0 from "./AliOssManager.vue?vue&type=style&index=0&id=3c02f2c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c02f2c6",
  null
  
)

export default component.exports